import gameConstants from './gameConstants';
import roundRegistry from './roundRegistry';

let debug = false;

if (localStorage.debug === 'pass') {
    initDebug();
}

function initDebug() {
    debug = true;

    for (const key in gameConstants) {
        if (localStorage[key] !== undefined) {
            gameConstants[key] = Number(localStorage[key]);
        }
    }

    console.log(JSON.stringify(roundRegistry, null, 4));
}

export function setAppSetState(setState) {
    if (!debug) {
        return;
    }

    window.setRound = round => {
        setState(state => ({
            game: {
                ...state.game,
                round,
            },
        }));
    };

    window.nextRound = () => {
        setState(state => ({
            game: {
                ...state.game,
                round: (state.game.round + 1) % 6,
            },
        }));
    };
}
